"use strict";

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/locale-provider/style/index.js
// module id = 1202
// module chunks = 1